import React from 'react';
import './Icon.scss';

export type IconProps = {
    icon: React.ReactNode | string;
    size: number;
} & {
    color?:  'secondary' | 'primary' | 'purple-cosem' | 'blue-cosem' | 'grey1' | "sky" | "turquoise" | "apple-green" | "green-water" | "green" | 'white' | 'error';
    variant?: 'plain' | 'surrounded';
    bordered?: boolean;
    rounded?: boolean;
    iconInsetSpacing?: number;
} & React.HTMLAttributes<HTMLDivElement>;

export const Icon: React.FC<IconProps> = ({
    icon,
    className,
    size,
    color = 'grey1',
    variant = 'plain',
    bordered = false,
    rounded = false,
    iconInsetSpacing,
    ...props
}) => {

    return (
        <span
            className={`icon ${className ?? ''}`}
            {...props}
            data-variant={variant}
            data-size={`${size}px`}
            data-color={color}
            data-bordered={bordered}
            data-rounded={rounded}
            style={
                {
                    '--icon-size': `${size}px`,
                    '--icon-inset-spacing': iconInsetSpacing ? `${iconInsetSpacing}px` : undefined
                } as React.CSSProperties
            }
        >
            {icon}
        </span>
    );
};
